import React from "react";

import classnames from "classnames";

import { BodyMedium } from "Cobalt/BodyText";
import { Collapse } from "Cobalt/Collapse";
import { TitleSmall } from "Cobalt/Header";
import ProgressBar from "Cobalt/ProgressBar";
import { Col, Row } from "Common/Grid";
import { Div } from "Common/HTML";
import Icon from "Common/Icon";
import { SizeSwitch } from "Common/Responsive";
import { Card, CardSection } from "Theme/Card";

import makeBem from "Utils/makeBem";

const bem = makeBem("ApplicationStepCard");

const cardTallySection = (cardTally) => (
  <Div className="w-[44px]">
    <ProgressBar value={cardTally.complete} max={cardTally.complete + cardTally.incomplete} size="medium" withText />
  </Div>
);

const TitleSection = ({ isOpen, cardTitle, cardTally }) => {
  return (
    <>
      <Div className={bem("IconAndTitle")}>
        <Div className={bem("CobaltToggleIconContainer")} mr={3}>
          <Icon icon={isOpen ? "angle-down" : "angle-right"} size="2x" />
        </Div>
        <Div mr={3}>
          <TitleSmall>{cardTitle}</TitleSmall>
        </Div>
      </Div>
      {cardTally && cardTallySection(cardTally)}
    </>
  );
};

const ContentSection = ({ cardSubtitle, cardBody }) => (
  <>
    <Row mb={4}>
      <Col>{cardSubtitle && <BodyMedium cobaltProps={{ className: bem("CardSubtitle"), mb: 5 }}>{cardSubtitle}</BodyMedium>}</Col>
    </Row>
    {cardBody}
  </>
);

const DesktopCard = ({ isOpen, isComplete, cardTitle, cardTally, toggleOpenCard, cardSubtitle, cardBody }) => (
  <Card mt={4} p={0} className={classnames(bem(), isOpen ? bem(null, "open") : bem(null, "closed"))}>
    <CardSection className={bem("Container")} onClick={toggleOpenCard}>
      <TitleSection isOpen={isOpen} cardTitle={cardTitle} cardTally={cardTally} />
    </CardSection>
    <Collapse in={isOpen} mountOnEnter>
      <CardSection style={{ borderTop: "1px solid #e0e0e0" }}>
        <ContentSection cardSubtitle={cardSubtitle} cardBody={cardBody} />
      </CardSection>
    </Collapse>
  </Card>
);

const MobileCard = ({ isOpen, cardTitle, cardTally, toggleOpenCard, cardSubtitle, cardBody }) => (
  <Div className={bem(null, "mobile")} py={4}>
    <Div className={bem("Container")} onClick={toggleOpenCard} py={4}>
      <TitleSection isOpen={isOpen} cardTitle={cardTitle} cardTally={cardTally} />
    </Div>
    <Collapse in={isOpen} mountOnEnter>
      <ContentSection cardSubtitle={cardSubtitle} cardBody={cardBody} />
    </Collapse>
  </Div>
);

const ExpandingApplicationStepCardDumbV2 = (props) => <SizeSwitch xs={<MobileCard {...props} />} sm={<DesktopCard {...props} />} />;

export default ExpandingApplicationStepCardDumbV2;
